export default "__VITE_ASSET__UOCJmKlf__"